module.exports = __webpack_public_path__ + "static/media/bottomImage.e3b5e2fa.svg";